import * as React from "react";
import { match } from 'react-router-dom';
import { Spinner, Bullseye } from "@patternfly/react-core";

export interface ComponentLoaderProps {
    componentName: string;
    match?: match;
}

// Lazy loaded component list
export enum EComponentList {
  ImageList = "ImageList",
  FourOhFour = "FourOhFour",
  SetupPreflight = "SetupPreflight",
  TestingOptions = "TestingOptions",
  UpdateGraph = "UpdateGraph",
  SellOnMarketplace = "SellOnMarketplace",
  Vulnerabilities = "Vulnerabilities",
  Certifications = "Certifications",
  Security = "Security",
  SharedTestResults = "SharedTestResults",
  RepositoryInfo = "RepositoryInfo",
  ComponentDetails = "ComponentDetails",
  ContactsInfo = "ContactsInfo",
  OptionalQualifications = "OptionalQualifications",
  AssociatedProduct = "AssociatedProduct"
}

class ComponentLoader extends React.Component<ComponentLoaderProps, {}> {

    getComponentPath = (componentName: string): Promise<any> => {
        switch (componentName) {
            case EComponentList.RepositoryInfo:
                return import(/* webpackChunkName: "RepositoryInfo" */ "../../RepositoryInfo/RepositoryInfo");
            case EComponentList.ImageList:
              return import(/* webpackChunkName: "ImageList" */ "../../Images/ImageListWrapper");
            case EComponentList.SetupPreflight:
              return import(/* webpackChunkName: "SetupPreflight" */"../../Images/Preflight/SetupPreflight");
            case EComponentList.TestingOptions:
              return import(/* webpackChunkName: "TestingOptions" */ '../../Certification/Operators/TestingOptions/TestingOptions');
            case EComponentList.UpdateGraph:
              return import(/* webpackChunkName: "UpdateGraph" */ "../../UpdateGraph/UpdateGraph");
            case EComponentList.SellOnMarketplace:
              return import(/* webpackChunkName: "SellOnMarketplace" */ "../../Certification/Operators/SellOnMarketplace/SellOnMarketplace");
            case EComponentList.Vulnerabilities:
              return import(/* webpackChunkName: "Vulnerabilities" */ "../../Security/Vulnerabilities/Vulnerabilities");
          case EComponentList.Certifications:
            return import(/* webpackChunkName: "CertificationsTab" */ "../../Certification/CertificationWrapper");
          case EComponentList.SharedTestResults:
            return import(/* webpackChunkName: "SharedTestResults" */ "../../Certification/SharedTestResults/SharedTestResults");
          case EComponentList.Security:
            return import(/* webpackChunkName: "Security" */ "../../Security/SecurityWrapper");
          case EComponentList.ComponentDetails:
            return import(/* webpackChunkName: "ComponentDetails" */ "../../ComponentDetails/ComponentDetails");
          case EComponentList.ContactsInfo:
            return import(/* webpackChunkName: "ContactInfo" */ "../../ContactInfo/ContactInfo");
          case EComponentList.OptionalQualifications:
            return import(/* webpackChunkName: "OptionalQualifications" */ "../../OptionalQualifications/OptionalQualifications");
          case EComponentList.AssociatedProduct:
            return import(/* webpackChunkName: "AssociatedProduct" */ "../../AssociatedProducts/AssociatedProducts");
          case EComponentList.FourOhFour:
            default:
              return import(/* webpackChunkName: "FourOhFour" */ "../ErrorPage/ErrorPage");
        }
    };

    getCompoment = () => {
        const Component = React.lazy(() =>
            this.getComponentPath(this.props.componentName)
        );
        return (
            <React.Suspense fallback={<Bullseye><Spinner /></Bullseye>}>
                <Component match={this.props.match}/>
            </React.Suspense>
        );
    };

    render() {
        return this.getCompoment();
    }
}

export default ComponentLoader;
